/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GlobalSettings } from '../../models/global-settings';

export interface GlobalMappingSettingsList$Params {
  PracticeId?: string | null;
}

export function globalMappingSettingsList(http: HttpClient, rootUrl: string, params?: GlobalMappingSettingsList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GlobalSettings>>> {
  const rb = new RequestBuilder(rootUrl, globalMappingSettingsList.PATH, 'get');
  if (params) {
    rb.query('PracticeId', params.PracticeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GlobalSettings>>;
    })
  );
}

globalMappingSettingsList.PATH = '/globalsettings/list';
